import Text from "common/Typography/Text";
import Modal from "common/Modal/Modal";
import React from "react";
import { OnboardingStyles } from "features/onboarding/common/styles";
import SubmitButton from "features/onboarding/common/SubmitButton";
import Link from "common/Typography/Link";
import { ConfirmAutoTradingModalProps } from "@shared/features/onboarding/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const ConfirmAutoTradingModal = ({
  isVisible,
  content,
  onOk,
  onCancel,
  buttonLoading,
  centered,
}: ConfirmAutoTradingModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  return (
    <Modal
      open={isVisible}
      footer={false}
      width={450}
      styles={{
        body: { padding: 32, textAlign: "center" },
      }}
      onCancel={onCancel}
      centered={centered}
    >
      <OnboardingStyles.ModalTitle style={{ marginBottom: 16 }}>
        {t("confirm_modal.title")}
      </OnboardingStyles.ModalTitle>
      {content?.map((text, index) => (
        <Text key={index} style={{ marginBottom: 16 }}>
          {text}
        </Text>
      ))}
      <SubmitButton
        onClick={onOk}
        loading={buttonLoading}
        style={{ margin: "16px 0" }}
      >
        {t("confirm_modal.continue_button")}
      </SubmitButton>
      <Link onClick={onCancel}>{t("confirm_modal.cancel_button")}</Link>
    </Modal>
  );
};

export default ConfirmAutoTradingModal;
